import { useEffect, useSyncExternalStore } from 'react';
import {
  getSourceDocument,
  subscribeSourceDocuments,
  warmSourceDocument,
  type SourceDocumentEntry,
} from '../utils/sourceDocumentCache';

/**
 * Subscribe to the in-memory cache entry for a source-document URL, and warm
 * it if it isn't already. Returns the cached EUR-Lex HTML entry (or undefined
 * for PDFs / not-yet-warmed), so the finding view can render from memory the
 * instant it's ready and fall back to a network iframe otherwise.
 */
export function useSourceDocument(
  url: string | null | undefined,
): SourceDocumentEntry | undefined {
  const entry = useSyncExternalStore(subscribeSourceDocuments, () =>
    getSourceDocument(url),
  );

  useEffect(() => {
    if (url) warmSourceDocument(url);
  }, [url]);

  return entry;
}
